import React from 'react';
import PropTypes from 'prop-types';

import YearSelect from '../input/YearSelect';
import EditableToggle from './EditableToggle';
import nullable from '../../utils/nullable';

// Returns null for an empty value so EditableToggle falls back to its pencil icon
const getYearDisplayValue = (value, withoutOption) => {
  if (value === 0) return withoutOption || null;
  return value ? String(value) : null;
};

const EditableYearSelect = ({
  onChange,
  value,
  readOnly = false,
  required = false,
  displayValue = null,
  withoutOption = null,
  ...rest
}) => (
  <EditableToggle
    onSubmit={onChange}
    value={value}
    readOnly={readOnly}
    required={required}
    displayValue={displayValue || getYearDisplayValue(value, withoutOption)}
    className="react-editable-xs"
  >
    {({ inputValue, setInputValue, inputRef, submit, handleKeyDown }) => (
      <YearSelect
        value={inputValue}
        onChange={year => setInputValue(year).then(submit)}
        onBlur={submit}
        onKeyDown={handleKeyDown}
        inputRef={inputRef}
        required={required}
        withoutOption={withoutOption}
        {...rest}
      />
    )}
  </EditableToggle>
);

EditableYearSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: nullable(PropTypes.number).isRequired,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  displayValue: PropTypes.node,
  // Label for the "without year" option, which submits 0 instead of null
  withoutOption: PropTypes.string,
};

export default EditableYearSelect;
